<ng-container>
  <div class="field-container">
    <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
    <p-select [(ngModel)]="selectedValue" [options]="list" placeholder="Seleccione" size="small" [showClear]="showClear"
      (onChange)="changeSelected($event)" class="w-full" [emptyMessage]="'No hay coincidencias'" appendTo="body"
      optionLabel="label" class="{{inputClass}}" [ngClass]="[recovery ? 'recover-data' : '']" [disabled]="disabled"
      autocomplete="off" />
  </div>
</ng-container>